import {useEffect, useState} from "react";
import {License} from "../interfaces/License";
import {useQuery} from "@tanstack/react-query";
import axios from "axios";
import {links} from "../../../utils/links";
import {getJWT} from "../../../utils/storageService";
import {useNavigate} from "react-router-dom";


const useLicensesQuery = () => {

    const jwt = getJWT();
    const navigate = useNavigate()

    return useQuery({
        queryKey: ['licenses'],
        queryFn: () => axios
            .get<License[]>(links.getModule, {
                headers: {
                    Authorization: `Bearer ${jwt}`
                }
            })
            .then(res => res.data)
            .catch(error => {
                localStorage.removeItem("jwt");
                navigate("/login")
            })
    })
}

export default useLicensesQuery;